import React, { useEffect, useState } from "react";
import PlantillaScreen from "../../../helpers/PlantillaScreen";
import request from "../../../../Helpers/API";
import { useBox } from "../../Helper/useBox";
import Swal from "sweetalert2";
import SaveIcon from "@mui/icons-material/Save";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useHistory, useLocation } from "react-router-dom";
import { LoaderScreen } from "../../../components/LoaderScreen";
import { FiltroGuiaCXC } from "./FiltroGuiaCXC";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";

export const GuiaCXCMainScreen = () => {
    const history = useHistory();

    const location = useLocation();

    const filtroGuardado = (() => {
        const raw = sessionStorage.getItem("rotacion_cxc_filtro");
        return raw ? JSON.parse(raw)?.filtro : null;
    })();

    const [tipoUbicacion, setTipoUbicacion] = useState(filtroGuardado?.tipo_ubi || "G");
    const [ubicacion, setUbicacion] = useState(filtroGuardado?.id || 0);

    const ejercicioSelect = location.state?.ejercicioSelect || 0;
    const periodoSelect = location.state?.periodoSelect || 0;
    const sucursales = location.state?.sucursales;
    const sucursalesSeleccionadas = location.state?.sucursalesSeleccionadas || 0;

    console.log(ejercicioSelect)

    const tiposUbi = [
        { id: "G", label: "Grupo" },
        { id: "R", label: "Región" },
        { id: "S", label: "Sucursal" },
    ];

    const reg = [
        { id: 1, label: "Sinaloa" },
        { id: 2, label: "Nayarit" },
    ];

    const suc = [
        { id: 1, label: "Navolato" },
        { id: 2, label: "Tepic" },
        { id: 11, label: "Caimanero" },
        { id: 12, label: "San Jose" },
        { id: 21, label: "ElDorado" },
        { id: 22, label: "Santiago I." },
        { id: 31, label: "Costa Rica" },
        { id: 32, label: "Tecuala" },
        { id: 41, label: "La Cruz" },
        { id: 42, label: "Las Varas" },
        { id: 51, label: "El Rosario" },
        { id: 52, label: "San Vicente" },
        { id: 61, label: "Villa Union" },
    ];

    const getOpcionesUbicacion = () => {
        switch (tipoUbicacion) {
            case "G":
                return [{ id: 0, label: "Grupo" }];

            case "R":
                return reg;

            case "S":
                return suc || [];

            default:
                return [];
        }
    };

    const [boxstate, setBoxState] = useBox();
    const [data, setData] = useState([]);
    const [post, setPost] = useState([]);
    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

    // Meses del año
    const meses = [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre",
    ];

    const buildPayloadItem = (item) => ({
        idlinea: item.idlinea,
        linea: item.linea,
        ejercicio: item.ejercicio,

        enero: item.enero ?? 0,
        febrero: item.febrero ?? 0,
        marzo: item.marzo ?? 0,
        abril: item.abril ?? 0,
        mayo: item.mayo ?? 0,
        junio: item.junio ?? 0,
        julio: item.julio ?? 0,
        agosto: item.agosto ?? 0,
        septiembre: item.septiembre ?? 0,
        octubre: item.octubre ?? 0,
        noviembre: item.noviembre ?? 0,
        diciembre: item.diciembre ?? 0,

        anual: item.anual ?? 0,

        semestre1: item.semestre1 ?? 0,
        semestre2: item.semestre2 ?? 0,
    });

    // Función para manejar los cambios de los inputs
    const handleChange = (idlinea, mes, value) => {
        value = Number(value);

        setData((prevData) => {
            const newData = prevData.map((item) => {
                if (item.idlinea === idlinea) {
                    return {
                        ...item,
                        [mes]: value,
                    };
                }
                return item;
            });

            // 🔥 SOLO actualizar la línea modificada
            const updatedItem = newData.find(i => i.idlinea === idlinea);

            setPost((prevPost) => {
                const existingIndex = prevPost.findIndex(p => p.idlinea === idlinea);

                const newItem = buildPayloadItem(updatedItem);

                if (existingIndex !== -1) {
                    const copy = [...prevPost];
                    copy[existingIndex] = newItem;
                    return copy;
                } else {
                    return [...prevPost, newItem];
                }
            });

            return newData;
        });
    };

    // console.log(data)

    const handlePromedioChange = (idlinea, value) => {
        value = Number(value);

        setData((prevData) => {
            const newData = prevData.map((item) => {
                if (item.idlinea === idlinea) {
                    const updatedItem = { ...item };

                    meses.forEach((mes) => {
                        updatedItem[mes.toLowerCase()] = value;
                    });

                    return updatedItem;
                }
                return item;
            });

            const updatedItem = newData.find(i => i.idlinea === idlinea);

            setPost((prevPost) => {
                const existingIndex = prevPost.findIndex(p => p.idlinea === idlinea);

                const newItem = buildPayloadItem(updatedItem);

                if (existingIndex !== -1) {
                    const copy = [...prevPost];
                    copy[existingIndex] = newItem;
                    return copy;
                } else {
                    return [...prevPost, newItem];
                }
            });

            return newData;
        });
    };

    const onGuardar = () => {
        setLoader({ ...loader, mostrar: true });

        const payload = {
            tipo_ubi: tipoUbicacion,
            ubicacion: ubicacion,
            detalle: JSON.stringify(post)
        };

        if (tipoUbicacion !== "G" && !ubicacion) {
            Swal.fire("GUIA CXC", "Seleccione una ubicación", "warning");
            return;
        }


        request
            .post("RotacionCXC/GuardarGuiaCXC", payload)
            .then(async () => {
                setLoader({ ...loader, mostrar: false });
                await Swal.fire(
                    "GUIA CXC",
                    "Se registraron las guias",
                    "success"
                );
                setPost([]);
                onExecute(boxstate.ejercicio || ejercicioSelect);
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("FACTURACION", JSON.stringify(error), "error");
            });
    };

    useEffect(() => {
        if (!tipoUbicacion) return;

        if (tipoUbicacion === "G") {
            setUbicacion(0);
            onExecute(ejercicioSelect);
            return;
        }

        // Región / Sucursal requieren ubicación válida
        if (!ubicacion) return;

        onExecute(ejercicioSelect);
    }, [tipoUbicacion, ubicacion]);


    const onExecute = (ejercicio) => {
        return new Promise((resolve, reject) => {
            setLoader({ ...loader, mostrar: true });
            request
                .get(`RotacionCXC/ListadoGuiaCXC?ejercicio=${ejercicio}&tipo_ubi=${tipoUbicacion}&ubicacion=${ubicacion}`)
                .then((result) => {
                    setLoader({ ...loader, mostrar: false });
                    setData(Object.values(result).map(item => ({
                        ...item,
                        anual: item.anual ?? 0,
                        semestre1: item.semestre1 ?? 0,
                        semestre2: item.semestre2 ?? 0,
                    })));
                    setPost([])
                    return;
                })
                .catch((error) => {
                    setLoader({ ...loader, mostrar: false });
                    reject(error);
                    return;
                });
        });
    };


    // Boton Regresar
    const onBack = () => {
        history.push("/Finanzas/RotacionCXC", {
            ejercicioSelect: ejercicioSelect,
        });
    };

    return (
        <PlantillaScreen
            titulo={`GUIA CXC ${boxstate.ejercicio || ejercicioSelect}`}
            className={"guia-cxc-main-screen"}
            className_main={1}
        >
            <LoaderScreen loader={loader} />
            <div className="guia-cxc-actions">
                <div className="guia-cxc-boton-regresar-container"
                    onClick={() => onBack()}>
                    <ArrowBackIcon />
                    Regresar

                </div>
                <div className="guia-cxc-boton-filtro-container">
                    <FiltroGuiaCXC
                        onExecute={onExecute}
                        boxState={boxstate}
                        onBoxChange={setBoxState}
                        ejercicio={ejercicioSelect}
                    />
                </div>
            </div>

            <div className="control-filtrado-cxc">

                <FormControl size="small" fullWidth>
                    <InputLabel>Tipo ubicación</InputLabel>
                    <Select
                        value={tipoUbicacion}
                        label="Tipo ubicación"
                        onChange={(e) => {
                            setTipoUbicacion(e.target.value);
                            setUbicacion(0); // reset dependiente
                        }}
                    >
                        {tiposUbi.map((t) => (
                            <MenuItem key={t.id} value={t.id}>
                                {t.label}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>

                <FormControl size="small" fullWidth disabled={!tipoUbicacion}>
                    <InputLabel>Ubicación</InputLabel>
                    <Select
                        value={ubicacion}
                        label="Ubicación"
                        onChange={(e) => setUbicacion(e.target.value)}
                    >
                        {getOpcionesUbicacion().map((u) => (
                            <MenuItem
                                key={u.id}
                                value={u.id}
                            >
                                {u.label}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>

            </div>

            <div className="guia-cxc-tabla-main-container scroll">
                <table
                    cellPadding={0}
                    cellSpacing={0}
                >
                    <thead>
                        <tr>
                            <th>Tipo</th>
                            <th>Promedio</th>
                            {meses.map((mes, index) => (
                                <th key={index}>{mes}</th>
                            ))}
                            <th>Semestre 1</th>
                            <th>Semestre 2</th>
                            <th>Anual</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.map((item, rowIndex) => (
                            <tr key={rowIndex}>
                                <td>{item.linea}</td>

                                <td>
                                    <input
                                        type="number"
                                        onChange={(e) =>
                                            handlePromedioChange(item.idlinea, e.target.value)
                                        }
                                        placeholder="%"
                                    />
                                </td>

                                {meses.map((mes, monthIndex) => (
                                    <td key={monthIndex}>
                                        <input
                                            type="number"
                                            value={item[mes.toLowerCase()] ?? 0}
                                            onChange={(e) =>
                                                handleChange(item.idlinea, mes.toLowerCase(), e.target.value)
                                            }
                                            placeholder="%"
                                        />
                                    </td>
                                ))}
                                <td>
                                    <input
                                        type="number"
                                        value={item.semestre1 ?? 0}
                                        onChange={(e) =>
                                            handleChange(item.idlinea, "semestre1", e.target.value)
                                        }
                                        placeholder="%"
                                    />
                                </td>
                                <td>
                                    <input
                                        type="number"
                                        value={item.semestre2 ?? 0}
                                        onChange={(e) =>
                                            handleChange(item.idlinea, "semestre2", e.target.value)
                                        }
                                        placeholder="%"
                                    />
                                </td>
                                <td>
                                    <input
                                        type="number"
                                        value={item.anual ?? 0}
                                        onChange={(e) =>
                                            handleChange(item.idlinea, "anual", e.target.value)
                                        }
                                        placeholder="%"
                                    />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            {Object.keys(post).length > 0 && (
                <div className="guia-cxc-boton-guardar-container">
                    <button
                        className="guia-cxc-boton-guardar"
                        onClick={() => onGuardar()}
                    >
                        <SaveIcon />
                        Guardar
                    </button>
                </div>
            )}
        </PlantillaScreen>
    );
};
